import { REQUEST_STATUS } from "../../enum"
import EPGParser from "./epg-parser"
import EpgProgram from "./epg-program"
import EPGUtility from "./epg-utility"
import EPGProgramUI from "./views/epg-program-ui"
import EPGTimelineUI from "./views/epg-timeline-ui"
import { PromiseResolver } from "../grid/row-model"
import EPGConfig from "./epg-config"

export default class EpgChannel {

    id = ''
    repeatPrograms = 'false'
    displayName = ''
    image = ''
    epgUrl = ''
    programList: EpgProgram[] = []
    name = ''
    fetchStatus: REQUEST_STATUS = REQUEST_STATUS.NONE
    fetchPromise:PromiseResolver = new PromiseResolver()

    fetchEpgPrograms(dateRange:any, multiData=null): Promise<EpgChannel> {
        return new Promise(async (resolve,reject)=> {
            if (this.epgUrl && this.epgUrl !== '') {
                this.fetchStatus = REQUEST_STATUS.FETCHING
                try {
                    let data = multiData
                    if(!multiData) {
                        const results = await fetch(this.epgUrl)
                        data = await results.json()
                    }
                    await EPGParser.parseEPGData(this, data, dateRange)
                    this.fetchStatus = REQUEST_STATUS.OK
                    this.fetchPromise.resolve(this)
                } catch (e) {
                    this.fetchStatus = REQUEST_STATUS.FAIL
                    this.fetchPromise.resolve(this)
                }
            }
            resolve(this)
        })
    }

    createPrograms(dateRange: { startDate: Date, endDate: Date }, channelIndex?: any): any[] {
        let filteredItems: any[] = []
        let previousProgram:any 
        this.programList.map((program, index) => {
            //if (EPGUtility.isDateInRange(program, dateRange)) {
                const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
                const filteredProgram = {
                    x: pos.x,
                    h: EPGConfig.ChannelRowHeight,
                    w: pos.w,
                    type: EPGProgramUI,
                    justify: 'left',
                    fixed: true,
                    index: index,
                    channelIndex: channelIndex,
                    st: program.start_timeObj,
                    et: program.end_timeObj,
                    title: program.title,
                    image: program.image == '' ? this.image : program.image,
                    rating: program.rating,
                    description: program.description || ''
                }
                filteredItems.push(filteredProgram)
                previousProgram = filteredProgram
            //}
        })

        if (filteredItems.length > 0) {
            //console.log('EpgChannel: Filtered programs:', filteredItems)
        } else {
            filteredItems = this.createDummyPrograms(filteredItems, dateRange, channelIndex)
        }
        return filteredItems
    }

    createDummyProgram(st,et, dateRange, channelIndex, programIndex, fillprogram?:EpgProgram) {

        let program: EpgProgram = fillprogram || new EpgProgram()
        if(!fillprogram) {
            program.start_timeObj = st
            program.end_timeObj = et
            program.title = 'No Data'
            program.image = this.image
        }
        program.duration = (et - st) / 1000        
        const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
        const filteredItem = {
            x: pos.x,
            h: 72,
            w: pos.w,
            type: EPGProgramUI,
            justify: 'left',
            fixed: true,
            index: programIndex,
            channelIndex: channelIndex,
            st: program.start_timeObj,
            et: program.end_timeObj,
            title: program.title,
            image: program.image,
            rating: '',
            description: ''
        }
        return filteredItem
    }

    createDummyPrograms(filteredItems, dateRange, channelIndex) {
        // let lastEndObj
        // let index = 0
        // let duration = 600
        // if (filteredItems.length > 0) {
        //     lastEndObj = filteredItems.length - 1.et
        //     index = filteredItems.index
        //     duration =
        // } else {
        //     lastEndObj = dateRange.startDate
        // }
        const startTime = new Date(dateRange.startDate)
        startTime.setHours(startTime.getHours() - 1)
        for (let i = 0; i < 26; i++) {
            const st = new Date(startTime)
            const et = new Date(startTime)
            et.setHours(et.getHours() + 1)
            filteredItems.push(this.createDummyProgram(st, et, dateRange, channelIndex, i))
            // const program: EpgProgram = new EpgProgram()
            // program.start_timeObj = st
            // program.end_timeObj = et
            // program.duration = (et - st) / 1000
            // program.title = 'No Data'
            // program.image = this.image
            // const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
            // filteredItems.push({
            //     x: pos.x,
            //     h: 72,
            //     w: pos.w,
            //     type: EPGProgramUI,
            //     justify: 'left',
            //     fixed: true,
            //     index: i,
            //     channelIndex: channelIndex,
            //     paddingX: 5,
            //     st: program.start_timeObj,
            //     et: program.end_timeObj,
            //     title: program.title,
            //     image: program.image,
            //     rating: '',
            //     description: '',
            //     style: {
            //         paddingX: 5,
            //         contentSpacing: 5,
            //         round: 0
            //     }
            // })
            startTime.setHours(startTime.getHours() + 1)
        }
        return filteredItems
    }


    createTimeline(dateRange) {
        // let lastEndObj
        // let index = 0
        // let duration = 600
        // if (filteredItems.length > 0) {
        //     lastEndObj = filteredItems.length - 1.et
        //     index = filteredItems.index
        //     duration =
        // } else {
        //     lastEndObj = dateRange.startDate
        // }
        const filteredItems = []
        const startTime = new Date(dateRange.startDate)
        //startTime.setHours(startTime.getHours() - 1)
        for (let i = 0; i < 48; i++) {
            try {
                const st = new Date(startTime)
                const et = new Date(st)
                et.setMinutes(et.getMinutes() + 30,0,0)
                const program: EpgProgram = new EpgProgram()
                program.start_timeObj = st
                program.end_timeObj = et
                program.duration = (et - st) / 1000
                //program.title = EPGUtility.formatAMPM(startTime)
                program.start_time = startTime
                const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
                filteredItems.push({
                    x: pos.x,
                    h: 72,
                    w: pos.w,
                    type: EPGTimelineUI,
                    justify: 'left',
                    fixed: true,
                    index: i,
                    channelIndex: -1,
                    paddingX: 5,
                    st: program.start_timeObj,
                    et: program.end_timeObj,
                    title: program.title
                })
                startTime.setMinutes(st.getMinutes() + 30,0,0)
            } catch (e) {
                //console.log('Timeline on error:', e)
            }
        }
        return filteredItems
    }

    getNowPlayingProgram(currDate) {
        const program = this.programList.find(program => EPGUtility.isPlaying(program.start_timeObj, program.end_timeObj,currDate))
        return program
    }
}

